import { render, staticRenderFns } from "./corteCajaMostrador.vue?vue&type=template&id=e0aebdae&"
import script from "./corteCajaMostrador.vue?vue&type=script&lang=js&"
export * from "./corteCajaMostrador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QSeparator,QBtn,QForm,QInput,QIcon,QSpace,QMarkupTable,QTr,QTd,QTabs,QTab,QTabPanels,QTabPanel,QTable,QTooltip,QTh} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QCardSection,QSeparator,QBtn,QForm,QInput,QIcon,QSpace,QMarkupTable,QTr,QTd,QTabs,QTab,QTabPanels,QTabPanel,QTable,QTooltip,QTh})
